// extracted by mini-css-extract-plugin
export default {"like__wrapper":"like_section_like__wrapper__g70Qd"};